module.exports = __webpack_public_path__ + "static/media/r42.7025036e.jpg";